import Icon from '../components/Icon.vue'

Icon.register({
  suitcase: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M128 480H384V80C384 53.5 362.5 32 336 32H176C149.5 32 128 53.5 128 80V480zM192 96H320V128H192V96zM512 176V432C512 458.5 490.5 480 464 480H416V128H464C490.5 128 512 149.5 512 176zM96 480H48C21.5 480 0 458.5 0 432V176C0 149.5 21.5 128 48 128H96V480z'
      }
    ]
  }
})
